import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Typography, FormControl, InputLabel, Select, MenuItem, Checkbox, IconButton } from '@mui/material';
import Swal from 'sweetalert2';
import { compound, createunit, featuress, placetype, unittypess } from '../../../components/Apis';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateCalendar, LocalizationProvider, PickersDay } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { format } from 'date-fns';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import MapComp from '../../../components/map/map';
// import { LicenseInfo } from "@mui/x-license-pro";
// LicenseInfo.setLicenseKey("Pask"); // Hides the warning

const Addunit = ({ open, onClose ,render }) => {
  const [features, setfeatures] = useState([])
  const [unittypes, setunittypes] = useState([])
  const [compounds, setcompounds] = useState([])
  const [brokers, setbrokers] = useState([])
  console.log(brokers)
  const [placetypes, setplacetypes] = useState([])
  const [owner, setowner] = useState([])
  const daysOff = ['2025-2-04', '2025-2-05', '2025-2-06', '2025-2-07', '2025-2-08', '2025-2-09', '2025-2-10']
  console.log(daysOff[daysOff.length - 1])
  const [EditItem, setEditItem] = useState({
    id: "",
    name: '',
    images: [],
    contract: null,
    documents: null,
    description: null,
    house_rules: "",
    map_url: "",
    available_from: null,
    available_to: null,
    off_days: [],
    price: "",
    lat: "0.00000",
    lng: "0.00000",
    adults: "0",
    children: "0",
    pets: "0",
    bedrooms: "0",
    bed: "0",
    bathrooms: "0",
    beach_passes: "0",
    unit_type_id: "",
    features_id: [],
    place_type_id: "",
    compound_id: "",
    owner_id: "",
    check_in: "03:20:00",
    check_out: "05:20:00",
    status: "",
    fees: "",
    deposit: "",
    insurance: "",
    maintenance: "",
    broker: "",
    broker_id: "",
    cancellation: [],
    edit: "",
    note: ""
  });

  console.log("ddj;kfsdkfiirfdkjfkdjf", EditItem.images);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditItem((prev) => ({ ...prev, [name]: value }));
  };

  const [files, setFiles] = useState({
    images: [],
    contract: null,
    documents: null,
  });

  const handleImageChange = (e) => {
    const selectedFiles = e.target.files;
    const validImageFiles = [];
    const maxTotalSize = 8 * 1024 * 1024; // 8MB total limit
    let totalSize = 0;

    // Check total size of existing images
    files.images.forEach(file => {
      totalSize += file.size;
    });

    // Check each new file
    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];

      if (!file.type.startsWith("image/")) {
        Swal.fire("Error", "Please upload only image files!", "error");
        return;
      }

      // Check if adding this file would exceed total size limit
      if (totalSize + file.size > maxTotalSize) {
        Swal.fire("Error", "Total image size cannot exceed 8MB!", "error");
        return;
      }

      totalSize += file.size;
      validImageFiles.push(file);
    }

    // Add valid files to state
    setFiles((prevFiles) => ({
      ...prevFiles,
      images: [...prevFiles.images, ...validImageFiles],
    }));
  };

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    setFiles((prevFiles) => ({
      ...prevFiles,
      [name]: name === "images" ? [...selectedFiles] : selectedFiles[0],
    }));
  };


  const handleDateChange = (field, date) => {
    setEditItem((prev) => ({
      ...prev,
      [field]: dayjs(date).format('YYYY-MM-DD'),
    }));
  };

  const handleChangee = (date) => {
    const formattedDate = format(date, 'yyyy-MM-dd'); // Format the selected date
    console.log(formattedDate);

    // Update the off_days array
    setEditItem((prevState) => {
      // Ensure off_days is an array if it's null
      const updatedOffDays = Array.isArray(prevState.off_days)
        ? prevState.off_days.includes(formattedDate)
          ? prevState.off_days
          : [...prevState.off_days, formattedDate]
        : [formattedDate]; // Initialize as array if it's null

      return {
        ...prevState,
        off_days: updatedOffDays, // Store the updated off_days array
      };
    });
  };

  const handleChanges = (value) => {
    if (value === undefined) return; // التحقق من القيم قبل استخدامها

    // تحويل القيم النصية إلى القيم الرقمية
    const updatedValue = value === "Active" ? "1" : value === "InActive" ? "0" : value;
    console.log(updatedValue)

    setEditItem((prev) => ({
      ...prev,
      edit: updatedValue, // تحديث الحالة بالقيمة المحوّلة
    }));
  };

  const fetchfeatures = async () => {

    try {


      const response = await featuress();
      console.log("my response", response)
      setfeatures(response)

    } catch (error) {
      console.error('Error fetching unit:', error);

    } finally {
    }
  };
  const fetchunittypes = async () => {

    try {


      const response = await unittypess();
      setunittypes(response)
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };

  const fetchcompound = async () => {

    try {


      const response = await compound();
      console.log(response)
      setcompounds(response)
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };
  const fetchplacetypes = async () => {
    try {
      const response = await placetype();
      console.log(response)
      setplacetypes(response)
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };

  useEffect(() => {

    fetchplacetypes()
    fetchcompound()
    fetchunittypes()
    fetchfeatures()

  }, []);

  const HandleSubmit = async () => {
    // Compress images before upload
    const compressImage = async (file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          const img = new Image();
          img.src = event.target.result;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const MAX_WIDTH = 1024;
            const scaleSize = MAX_WIDTH / img.width;
            canvas.width = MAX_WIDTH;
            canvas.height = img.height * scaleSize;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            canvas.toBlob((blob) => {
              resolve(new File([blob], file.name, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              }));
            }, 'image/jpeg', 0.7); // Compress with 70% quality
          };
        };
      });
    };

    try {
      const formData = new FormData();
      formData.append("name", EditItem.name);
      formData.append("description", EditItem.description);
      formData.append("available_from", EditItem.available_from);
      formData.append("available_to", EditItem.available_to);
      formData.append("lat", EditItem.lat);
      formData.append("lng", EditItem.lng);
      formData.append("adults", EditItem.adults);
      formData.append("children", EditItem.children);
      formData.append("pets", EditItem.pets);
      formData.append("bedrooms", EditItem.bedrooms);
      formData.append("bed", EditItem.bed);
      formData.append("bathrooms", EditItem.bathrooms);
      formData.append("beach_passes", EditItem.beach_passes);
      formData.append("unit_type_id", EditItem.unit_type_id);
      formData.append("place_type_id", EditItem.place_type_id);
      formData.append("compound_id", EditItem.compound_id);
      formData.append("note", EditItem.note);
      formData.append("check_in", EditItem.check_in);
      formData.append("check_out", EditItem.check_out);
      formData.append("images", EditItem.images);
      // formData.append("off_days", JSON.stringify(dateRange)); // Send as a single array
      // formData.append("off_days",JSON.stringify(dateRange.map((ele)=>{return ele})))
      formData.append("map_url", EditItem.map_url);
      dateRange.forEach(date => formData.append("off_days[]", date));
      formData.append("house_rules", EditItem.house_rules);
      // formData.append("off_days",JSON.stringify(EditItem.off_days)||[]);

      if (EditItem.features_id) {
        EditItem.features_id.forEach((day, index) => {
          formData.append(`features_id[${index}]`, day);
        });
      }

      // Compress and append images
      if (files.images.length > 0) {
        for (const file of files.images) {
          const compressedFile = await compressImage(file);
          formData.append("images[]", compressedFile);
        }
      }

      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
      onClose()

      console.log("Form data before send",formData)
      Swal.showLoading();
      const res = await createunit(formData)

      Swal.close();


      console.log(res)

      if (res.success) {
        Swal.fire("Success", "Unit Created Successfully", "success");
        render() // to render the page in add new unit 
        // window.location.reload();
      } else {
        Swal.fire("Error", res.message || "Failed to create unit", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Failed to create unit", "error");
      // console.error(error);
    }
  }

  const convertDatesToDateObjects = (dates) => {
    return dates
      .map(date => dayjs(date).isValid() ? new Date(date) : null)
      .filter(Boolean);
  };



  // Part function of Unavailably dates ---------------------------------------------------------------------------------
  // const [dateRange, setDateRange] = useState([]);
  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);

  // const generateDateArray = (start, end) => {
  //   let dates = [];
  //   let currentDate = dayjs(start);

  //   while (currentDate.isBefore(dayjs(end)) || currentDate.isSame(dayjs(end))) {
  //     dates.push(currentDate.format("YYYY-M-D"));
  //     currentDate = currentDate.add(1, "day");
  //   }
  //   return dates;
  // };

  // const handleStartDateChange = (newStart) => {
  //   setStartDate(newStart);
  //   if (newStart && endDate) {
  //     const formattedDates = generateDateArray(newStart, endDate);
  //     setDateRange(formattedDates);
  //     setEditItem((prev) => ({
  //       ...prev,
  //       off_days: formattedDates,
  //     }));
  //     console.log("Selected Date Range:", formattedDates);
  //   }
  // };

  // const handleEndDateChange = (newEnd) => {
  //   setEndDate(newEnd);
  //   if (startDate && newEnd) {
  //     const formattedDates = generateDateArray(startDate, newEnd);
  //     setDateRange(formattedDates);
  //     setEditItem((prev) => ({
  //       ...prev,
  //       off_days: formattedDates,
  //     }));
  //     console.log("Selected Date Range:", formattedDates);
  //   }
  // };



  const [dateRange, setDateRange] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);

  const handleDateClick = (newDate) => {
    const formattedDate = dayjs(newDate).format("YYYY-M-D");
    console.log("mmmmvnjjdfjfjdsdfjj", formattedDate);


    setDateRange((prev) =>
      prev.includes(formattedDate)
        ? prev.filter((date) => date !== formattedDate) // Remove if already selected
        : [...prev, formattedDate] // Add new date
    );

  };

  const handleSubmit = () => {
    setEditItem((prev) => ({
      ...prev,
      off_days: [...dateRange], // ✅ Save selected dates to `EditItem.off_days`
    })); // Store selected dates
    setShow(false); // ✅ Properly closes the popup
    console.log("Submitted Dates:", dateRange); // Log for testing
  };

  // Part function of Unavailably dates ---------------------------------------------------------------------------------



  const [mapDialogOpen, setMapDialogOpen] = useState(false);

  return (
    <Dialog open={open} dir="ltr" onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        Add Unit
        <IconButton onClick={onClose} sx={{ color: "#a0553a", "&:hover": { backgroundColor: "transparent", color: "#a0553a" } }}>
          x
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "flex-start", gap: '15px', paddingLeft: "5rem" }}>
        <TextField
          name="name"
          label="Name"
          type="text"
          value={EditItem.name || ''}
          onChange={handleChange}
          // fullWidth
          sx={{ width: '30%' }}
          margin="normal"
        />
        <TextField
          name="description"
          label="Description"
          type="text"
          value={EditItem.description || ''}
          onChange={handleChange}
          // fullWidth
          sx={{ width: '30%' }}
          margin="normal"
        />
        <TextField
          name="note"
          label="Note"
          type="text"
          value={EditItem.note || ''}
          onChange={handleChange}
          // fullWidth
          sx={{ width: '30%' }}
          margin="normal"
        />

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {/* available dates -----------------------------------------------------------*/}
          {/* <Typography variant="subtitle2" gutterBottom>
                Available From
              </Typography> */}
          <Box sx={{ my: 0, width: '46%' }}>
            <DatePicker
              label="Available From"
              value={EditItem.available_from ? dayjs(EditItem.available_from) : null}
              onChange={(date) => handleDateChange('available_from', date)}
              shouldDisableDate={(date) => {
                const formattedDate = dayjs(date).format('YYYY-MM-DD');
                return (
                  (EditItem.available_from && dayjs(date).isBefore(dayjs(EditItem.available_from))) ||
                  (EditItem.available_to && dayjs(date).isAfter(dayjs(EditItem.available_to))) ||
                  (EditItem.off_days?.includes(formattedDate))
                );
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  margin: "normal",
                  inputProps: {
                    dir: "ltr"
                  }
                },
                popper: {
                  sx: {
                    direction: "ltr",
                    '& .MuiPickersCalendarHeader-root': {
                      direction: "ltr"
                    },
                    '& .MuiPickersCalendar-root': {
                      direction: "ltr"
                    }
                  }
                }
              }}
            />
          </Box>

          <Box sx={{ my: 0, width: '46%' }} >
            {/* <Typography variant="subtitle2" gutterBottom>
                Available To
              </Typography> */}
            <DatePicker
              label="Available To"
              value={EditItem.available_to ? dayjs(EditItem.available_to) : null}
              onChange={(date) => handleDateChange('available_to', date)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  margin: "normal",
                  inputProps: {
                    dir: "ltr"
                  }
                },
                popper: {
                  sx: {
                    direction: "ltr",
                    '& .MuiPickersCalendarHeader-root': {
                      direction: "ltr"
                    },
                    '& .MuiPickersCalendar-root': {
                      direction: "ltr"
                    }
                  }
                }
              }}
            />
          </Box>
          {/* available dates -----------------------------------------------------------*/}


          {/* <Typography variant="subtitle2" gutterBottom>
              Unavailable Dates
            </Typography> */}

          {/* Start UnAvailably Dates------------------------------------------------------------------------------------- */}

          <Box textAlign="center" sx={{ width: "46%" }}>
            {/* <Typography variant="h6" onClick={() => setShow(true)}>Select Dates</Typography> */}
            <TextField
              label="Unavailable dates"
              fullWidth
              sx={{ width: '100%' }}
              margin="normal"
              onClick={() => setShow(true)}
              InputProps={{ readOnly: true }}
            />
            {/* <Button variant="contained" >
              Open Calendar
            </Button> */}

            {/* Display Selected Dates */}
            {/* {selectedDates.length > 0 && (
              <Typography variant="body1" sx={{ mt: 2 }}>
                Selected Dates: {selectedDates.join(", ")}
              </Typography>
            )} */}

            {/* Popup Calendar */}
            <Dialog open={show} onClose={() => setShow(false)} maxWidth="xs" dir="ltr">
              <DialogContent sx={{ textAlign: "center", p: 3 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Select Dates
                </Typography>
                <DateCalendar
                  onChange={handleDateClick}
                  slots={{
                    day: (props) => {
                      const formattedDate = dayjs(props.day).format("YYYY-M-D");
                      const isSelected = dateRange.includes(formattedDate);

                      return (
                        <PickersDay
                          {...props}
                          sx={{
                            backgroundColor: isSelected ? "#2196F3 !important" : "transparent",
                            color: isSelected ? "white" : "inherit",
                            borderRadius: "50%",
                            "&:hover": { backgroundColor: "#e0e0e0" },
                          }}
                        />
                      );
                    },
                  }}
                />
              </DialogContent>

              {/* Action Buttons */}
              <DialogActions sx={{ justifyContent: "space-around", p: 2 }}>
                <Button variant="outlined" onClick={() => setShow(false)}
                  sx={{
                    backgroundColor: "#a0553a",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#a0553a",
                      color: "white",
                    },
                  }}
                >
                  Close
                </Button>
                <Button variant="contained" onClick={handleSubmit}
                  sx={{
                    backgroundColor: "#a0553a",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#a0553a",
                      color: "white",
                    },
                  }}
                >
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
          </Box>

          {/*End UnAvailably Dates------------------------------------------------------------------------------------- */}

        </LocalizationProvider>
        <Box mb={1} sx={{ border: '1px solid #ccc', display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "4rem", borderRadius: '4px', padding: '8px', height: "3.5rem", marginTop: "15px", width: "46%" }}>

          <Typography variant="body2" sx={{ fontSize: "1rem", color: "gray" }}>
            Upload Images
          </Typography>
          {/* <input
            type="file"
            name="images"
            accept="image/*"
            multiple
            onChange={handleImageChange}
          /> */}
          <Button
            component="label"
            sx={{
              backgroundColor: "#a0553a",
              color: "white",
              "&:hover": {
                backgroundColor: "#a0553a",
              }
            }}
          >
            Choose Files
            <input
              type="file"
              name="images"
              accept="image/*"
              multiple
              onChange={handleImageChange}
              hidden
            />
          </Button>
        </Box>


        {EditItem.images.length > 0 && (
          <Typography variant="body2" sx={{ marginTop: '8px' }}>
            Selected Images: {EditItem.images.length}
          </Typography>
        )}

        <TextField
          name="house_rules"
          label="House Rules"
          type="text"
          value={EditItem.house_rules || ''}
          onChange={handleChange}
          // fullWidth
          sx={{ width: '46%' }}
          margin="normal"
        />

        <FormControl fullWidth margin="normal" sx={{ width: "46%" }}>
          <InputLabel sx={{
            backgroundColor: "white",
            px: 1, // Padding left and right to cover the border
            "&.Mui-focused": {
              backgroundColor: "white",
            }
          }}>
            Features
          </InputLabel>
          <Select
            name="features_id"
            value={EditItem.features_id || []} // القيمة الحالية من الحالة
            onChange={(e) => {
              const value = e.target.value.map(String); // تحويل القيم إلى نصوص
              setEditItem((prev) => ({
                ...prev,
                features_id: value, // تحديث المصفوفة بالقيم النصية
              }));
            }}
            multiple
            renderValue={(selected) =>
              selected
                .map((id) => features.find((feature) => feature.id.toString() === id)?.feature) // عرض أسماء المزايا
                .join(', ')
            }
          >
            {features.map((feature) => (
              <MenuItem key={feature.id} value={feature.id.toString()}> {/* تخزين القيمة كنص */}
                <Checkbox
                  checked={EditItem.features_id.includes(feature.id.toString())} // التحقق من النصوص
                  onChange={(e) => {
                    e.stopPropagation(); // منع فتح القائمة عند النقر على الـ Checkbox
                    setEditItem((prev) => {
                      const isSelected = prev.features_id.includes(feature.id.toString());
                      return {
                        ...prev,
                        features_id: isSelected
                          ? prev.features_id.filter((id) => id !== feature.id.toString()) // إزالة العنصر كنص
                          : [...prev.features_id, feature.id.toString()], // إضافة العنصر كنص
                      };
                    });
                  }}
                />
                {feature.feature}
              </MenuItem>
            ))}
          </Select>




        </FormControl>



        <FormControl fullWidth margin="normal" sx={{ width: "46%" }}>
          <InputLabel sx={{
            backgroundColor: "white",
            px: 1, // Padding left and right to cover the border
            "&.Mui-focused": {
              backgroundColor: "white",
            }
          }}>
            Unit Types
          </InputLabel>
          <Select
            name="unit_type_id"
            value={EditItem.unit_type_id}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                // Adjust border color if needed
                borderColor: "rgba(0, 0, 0, 0.23)"
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(0, 0, 0, 0.87)"
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#1976d2" // Or your theme primary color
              }
            }}
          >
            {unittypes.map((type, index) => (
              <MenuItem key={index} value={type.id}> {/* هنا القيمة هي owner_id */}
                {type.unit_type} {/* وعرض owner_name */}
              </MenuItem>
            ))}
          </Select>
        </FormControl>



        <FormControl fullWidth margin="normal" sx={{ width: "46%" }}>
          <InputLabel
            sx={{
              backgroundColor: "white",
              px: 1, // Padding left and right to cover the border
              "&.Mui-focused": {
                backgroundColor: "white",
              }
            }}>Compounds</InputLabel>
          <Select
            name="compound_id"
            value={EditItem.compound_id} // القيمة المختارة للـ owner_id
            onChange={handleChange} // عند تغيير الاختيار
          >
            {compounds.map((type, index) => (
              <MenuItem key={index} value={type.id}> {/* هنا القيمة هي owner_id */}
                {type.compound} {/* وعرض owner_name */}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal" sx={{ width: "46%" }}>
          <InputLabel
            sx={{
              backgroundColor: "white",
              px: 1, // Padding left and right to cover the border
              "&.Mui-focused": {
                backgroundColor: "white",
              }
            }}>Place Type</InputLabel>
          <Select
            name="place_type_id"
            value={EditItem.place_type_id} // القيمة المختارة للـ owner_id
            onChange={handleChange} // عند تغيير الاختيار
          >
            {placetypes.map((type, index) => (
              <MenuItem key={index} value={type.id}> {/* هنا القيمة هي owner_id */}
                {type.place_type} {/* وعرض owner_name */}
              </MenuItem>
            ))}
          </Select>
        </FormControl>



        {/* <TextField
          sx={{ my: 2 }}
          label="Check In"
          type="time"
          name="check_in"
          value={EditItem.check_in} // القيمة الحالية للوقت
          onChange={handleChange} // عند التغيير
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 1, // خطوة واحدة (ثانية واحدة)
          }}
        />
        <TextField
          sx={{ my: 2 }}
          label="Check Out"
          type="time"
          name="check_out"
          value={EditItem.check_out} // القيمة الحالية للوقت
          onChange={handleChange} // عند التغيير
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 1, // خطوة واحدة (ثانية واحدة)
          }}
        /> */}

        {/* ----------------------------------------------- Map Dialog --------------------------------------- */}
        {/* <div style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: "center", width: "46%" }}>
          <Button
            variant="contained"
            onClick={() => setMapDialogOpen(true)}
            sx={{
              backgroundColor: "#a0553a",
              color: "white",
              fontSize: "12px",
              "&:hover": {
                backgroundColor: "#a0553a",
              }
            }}
          >
            Select Location on Map
          </Button>

          <Dialog
            open={mapDialogOpen}
            dir="ltr"
            onClose={() => setMapDialogOpen(false)}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              Select Location
              <IconButton
                onClick={() => setMapDialogOpen(false)}
                sx={{
                  color: "#a0553a",
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "#a0553a"
                  }
                }}
              >
                x
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Box sx={{ height: "400px", width: "100%", mt: 2 }}>
                <MapComp
                  title={"title"}
                  allowMarkerClick
                  onClick={(e) => {
                    console.log("Clicked:", setEditItem((prev) => ({ ...prev, lat: e.lat, lng: e.lng })));
                    setMapDialogOpen(false);
                  }}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setMapDialogOpen(false)}
                sx={{
                  color: "#a0553a",
                  "&:hover": {
                    backgroundColor: "transparent",
                  }
                }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>

          <TextField
            name="lat"
            label="lat"
            type="text"
            sx={{ width: "50%" }}
            value={EditItem.lat || ''}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            name="lng"
            label="lng"
            type="text"
            sx={{ width: "50%" }}
            value={EditItem.lng || ''}
            onChange={handleChange}
            margin="normal"
          />
        </div> */}

        <TextField
          name="map_url"
          label="Map URL"
          type="text"
          value={EditItem.map_url ||''}
          onChange={handleChange}
          // fullWidth
          sx={{ width: '46%' }}
          margin="normal"
        />

        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: "center", width: "46%" }}>
          <TextField
            name="adults"
            label="adults"
            type="text"
            sx={{ width: "50%" }} value={EditItem.adults || ''}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            name="children"
            label="children"
            type="text"
            sx={{ width: "50%" }}
            value={EditItem.children || ''}
            onChange={handleChange}
            margin="normal"
          />
        </div>

        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: "center", width: "46%" }}>
          <TextField
            name="pets"
            label="pets"
            type="text"
            sx={{ width: "50%" }} value={EditItem.pets || ''}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            name="bedrooms"
            label="bedrooms"
            type="text"
            sx={{ width: "50%" }}
            value={EditItem.bedrooms || ''}
            onChange={handleChange}
            margin="normal"
          />
        </div>

        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: "center", width: "46%" }}>
          <TextField
            name="bed"
            label="bed"
            type="text"
            sx={{ width: "50%" }} value={EditItem.bed || ''}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            name="bathrooms"
            label="bathrooms"
            type="text"
            sx={{ width: "50%" }}
            value={EditItem.bathrooms || ''}
            onChange={handleChange}
            margin="normal"
          />
        </div>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', justifyContent: "flex-start", width: "46%" }}>
          <TextField
            name="beach_passes"
            label="beach passes"
            type="text"
            sx={{ width: "50%" }} value={EditItem.beach_passes || ''}
            onChange={handleChange}
            margin="normal"
          />

        </div>



      </DialogContent>

      <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
        {/* <Button onClick={onClose} style={{ width: "50%", color: "#a0553a" }}>Cancel</Button> */}
        <Button onClick={HandleSubmit} variant="contained" color="primary" style={{ width: "90%" }}
          sx={{
            mt: 2,
            padding: "10px",
            borderRadius: "8px",
            fontWeight: "bold",
            backgroundColor: "#a0553a",
            color: "white",
            "&:hover": {
              backgroundColor: "#a0553a",
              color: "white",
            },
          }}
        >Save</Button>
      </DialogActions>
    </Dialog>
  );
}

export default Addunit;

